import React, { Fragment } from 'react';
import { PlxsText } from '@plexlogic/plexus-ui';
import { EntriesUpload } from '../../types/DrawData';
import ConfirmationTable from './ConfirmationTable';
import useUploadStore, { useIsHeaderRow, useParticipantIdentificationColumn } from './useUploadStore';

interface ParticipantIdentificationQuestionProps {
  entriesUpload: EntriesUpload;
  questionNumber?: string; // For advanced mode numbering
  numericOnlyColumns?: string[]; // Columns to disable (for count-per-entrant mode)
  isDisabled?: boolean;
}

const ParticipantIdentificationQuestion: React.FC<ParticipantIdentificationQuestionProps> = ({
  entriesUpload,
  questionNumber,
  numericOnlyColumns = [],
  isDisabled = false
}) => {
  // Use typed selectors for proper store boundaries
  const isHeaderRowAnswer = useIsHeaderRow() ?? null;
  const participantIdentificationColumn = useParticipantIdentificationColumn();
  const setParticipantIdentificationColumn = useUploadStore((state) => state.setParticipantIdentificationColumn);

  const questionLabel = questionNumber
    ? `${questionNumber}. Winner identification column`
    : "Winner identification column";

  const handleParticipantIdentificationColumnChange = (column: string | null) => {
    setParticipantIdentificationColumn(column || undefined);
  };

  return (
    <Fragment>
      <PlxsText size="sm" weight='bold'>{questionLabel}</PlxsText>
      <div
        style={{
          marginTop: "var(--plexus-space-sm, 8px)",
          marginBottom: "var(--plexus-space-md, 16px)",
        }}
      >
        <PlxsText size="sm">
          Pick the column we'll use to identify winners – ideally one with unique
          values, like a name or ID. Leave it blank and we'll use the row number.
        </PlxsText>
      </div>

      {/* Table for participant identification selection - using unique-id-selection mode */}
      <div style={{ position: "relative" }}>
        <ConfirmationTable
          entriesUpload={entriesUpload}
          mode="unique-id-selection"
          uniqueIdColumn={participantIdentificationColumn}
          onUniqueIdColumnChange={handleParticipantIdentificationColumnChange}
          numericOnlyColumns={numericOnlyColumns}
          isEntryRow={isHeaderRowAnswer === false}
          isReadOnly={isDisabled}
        />
      </div>
    </Fragment>
  );
};

export default ParticipantIdentificationQuestion;
